import React, { createContext, ReactChild, useContext } from "react";
import { RegisteredComponent } from "./PluginRegistryTypes";

export interface PluginPlaceholderContextType {
  level: number;
  componentNames: string[];
}

export const PluginPlaceholderContext = createContext<PluginPlaceholderContextType>({
  level: 0,
  componentNames: [],
});

export interface PluginPlaceholderContextProviderProps {
  components: RegisteredComponent<any>[];
  children?: ReactChild | ReactChild[] | undefined | null;
}

export const PluginPlaceholderContextProvider = (props: PluginPlaceholderContextProviderProps) => {
  const { components, children } = props;
  const componentNames = components.map(component => component.name);
  const { level, componentNames: parentComponentNames } = useContext(PluginPlaceholderContext);
  const newComponentNames = Array.from(
    new Set([...(componentNames || []), ...(parentComponentNames || [])])
  );

  return (
    <PluginPlaceholderContext.Provider
      value={{ componentNames: newComponentNames, level: level + 1 }}
    >
      {children}
    </PluginPlaceholderContext.Provider>
  );
};
